module.exports = __webpack_public_path__ + "img/1.81471bd7.png";